var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"home container"},[_c('h2',{staticClass:"title"},[_vm._v("Benvenuto")]),_vm._v(" "),_c('p',{staticClass:"subtitle"},[_vm._v("\n    Per poter utilizzare l'applicazione è necessario effettuare\n    "),_c('router-link',{attrs:{"to":{name: 'Login'}}},[_vm._v("l'accesso")]),_vm._v(".\n  ")],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-656eda20","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Home.vue
// module id = 285
// module chunks = 1